import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from 'react-toastify';
import { MdDelete, MdEdit, MdHelpOutline } from "react-icons/md";
import { Table } from "@merchstores/shared/elements/Table";
import { CTA } from "@merchstores/shared/elements/Cta";
import { Tooltip } from "@merchstores/shared/elements/Tooltip";
import { IMerchStoreProduct, IMerchStoreProductListProps } from ".";
import { shopifyImageResize } from "@merchstores/shared/components/Shopify";
import { cloudinaryApplyWidthHeight } from "@merchstores/shared/components/Cloudinary";
import LoadingGif from "../../../assets/common/Flask-3s-200px.svg";

import "./styles.scss";

export const MerchStoreProductList: React.FC<IMerchStoreProductListProps> = (props: IMerchStoreProductListProps) => {
  const { products, setSelectedProduct, isMobile, deleteProduct } = props;
  const [collectionData, setCollectionData] = useState([]);

  useEffect(() => {
    if (products) {
      const collectionProductData = products.map(
        (product: IMerchStoreProduct) => {
          const data: any = {};
          const productImage = product.images[0];
          const imgSrc = productImage ? productImage.src : '';
          const formattedImage =
            imgSrc.indexOf("shopify") > -1
              ? shopifyImageResize(imgSrc, "thumb")
              : imgSrc.indexOf("cloudinary") > -1
              ? cloudinaryApplyWidthHeight(imgSrc, 36, 36)
              : imgSrc;
          data.image = {
            desktopOnly: false,
            value: (
              <div className="flex items-center ml-4">
                {product.images.length ? (
                  <div className="h-36 w36 bg-white border border-gray-300 rounded-md overflow-hidden">
                    <img src={formattedImage} alt={productImage ? productImage.altText: ''}/> 
                  </div>
                ) : (
                  <></>
                )}
                <div className="text-left pl-3 font-bold text-merch-dark-gray w-200 md:w-auto">
                  {product.title}
                </div>
              </div>
            ),
          };
          data.editAction = {
            desktopOnly: false,
            value: (
              <div className="flex w-full justify-end">
                <CTA
                  size="small"
                  type="mobile-icon"
                  onClick={() => {
                    setSelectedProduct(product);
                  }}
                >
                  {isMobile ? <MdEdit size="15px" /> : "View/Edit"}
                </CTA>
              </div>
            ),
          };

          data.deleteAction = {
            desktopOnly: false,
            value: 
              <CTA
                size="small"
                type="clear-background"
                onClick={() => {deleteProduct(product.id)}}
              >
                <MdDelete />
              </CTA>
          };

          return {
            tr: {
              class: "",
              data,
            },
          };
        }
      );
      setCollectionData(collectionProductData);
    }
  }, [props]);

  const sectionHeader = (text: string, tooltip?: string) => {
    return (
      <div className="flex items-center mb-2.5 pl-6 md:pl-0">
        <div className="text-sm text-merch-dark-gray font-bold">{text}</div>
        {tooltip && (
          <Tooltip content={props}>
            <div className="opacity-50 ml-2">
              <MdHelpOutline />
            </div>
          </Tooltip>
        )}
      </div>
    );
  };

  if (props.isLoading) return <div className="h-200 flex items-center justify-center"><img src={LoadingGif} alt="loading flask" width="100px"/></div>

  return (
    <>
      {sectionHeader("Products")}
      <div className="product-list-container">
        {collectionData.length ? (
          <Table itemsName="products" name="products" data={collectionData} />
        ) : (
          <div className="bg-merch-background-gray px-3 py-6 lg:p-6 rounded-md flex justify-between items-center">
            <div className="text-13 italic text-merch-dark-gray opacity-50 font-medium">
              Showing 0 of 0 products
            </div>
          </div>
        )}
      </div>
    </>
  );
};
